// DeleteandUpdate.js
import React, { useState } from "react";
import {
    useToast,
    Box,
    Button,
    Input,
    Modal,
    ModalOverlay,
    ModalContent,
    ModalHeader,
    ModalFooter,
    ModalBody,
    Select
} from "@chakra-ui/react";
import axios from "axios";
import { useSelector } from "react-redux";
import { BASE_URL1 } from "../Component/constants/config";

const DeleteandUpdate = ({
    _id,
    initialTitle,
    initialGenre,
    initialImage,
    initialDescription,
}) => {
    const [isOpen, setIsOpen] = useState(false);
    const [title, setTitle] = useState(initialTitle);
    const [genre, setGenre] = useState(initialGenre);
    const [image, setImage] = useState(initialImage);
    const [description, setDescription] = useState(initialDescription);
    const { token } = useSelector((state) => state.authReducer);
    const toast = useToast();

    const handleUpdateDetails = async () => {
        try {
            const res = await axios.patch(
                BASE_URL1 + `/blog/${_id}`,
                { title, genre, image, description },
                {
                    headers: {
                        Authorization: token,
                    },
                }
            );

            if (res.data.status === 1) {
                toast({
                    title: "Success",
                    description: "Details updated successfully.",
                    status: "success",
                    duration: 2000,
                    isClosable: true,
                });
                closeModal();
                window.location.reload();
            } else {
                toast({
                    title: "Error",
                    description: res.data.message,
                    status: "error",
                    duration: 2000,
                    isClosable: true,
                });
            }
        } catch (error) {
            toast({
                title: "Error",
                description: "An error occurred while updating details.",
                status: "error",
                duration: 2000,
                isClosable: true,
            });
        }
    };

    const handleDelete = async () => {
        try {
            const res = await axios.delete(BASE_URL1 + `/blog/${_id}`, {
                headers: {
                    Authorization: token,
                },
            });

            if (res.data.status === 1) {
                toast({
                    title: "Success",
                    description: "Blog deleted successfully.",
                    status: "success",
                    duration: 2000,
                    isClosable: true,
                });
                closeModal();
                // Reload the page after successful delete
                window.location.reload();
            } else {
                toast({
                    title: "Error",
                    description: res.data.message,
                    status: "error",
                    duration: 2000,
                    isClosable: true,
                });
            }
        } catch (error) {
            toast({
                title: "Error",
                description: "An error occurred while deleting the blog.",
                status: "error",
                duration: 2000,
                isClosable: true,
            });
        }
    };


    const openModal = () => {
        setIsOpen(true);
    };

    const closeModal = () => {
        setIsOpen(false);
    };

    return (
        <>
            <div style={{ display: "flex", gap: "8px", marginBottom: "16px" }}>
                <Button onClick={openModal} colorScheme="blue">
                    Edit Blog
                </Button>
                <Button onClick={handleDelete} colorScheme="red">
                    Delete Blog
                </Button>
            </div>
            <Modal isOpen={isOpen} onClose={closeModal}>
                <ModalOverlay />
                <ModalContent>
                    <ModalHeader>Update Details</ModalHeader>
                    <ModalBody>
                        <Input
                            type="text"
                            value={title}
                            onChange={(e) => setTitle(e.target.value)}
                            placeholder="Title"
                            marginBottom="2"
                        />
                        {/* Replace with the Select component */}
                        <Select
                            value={genre}
                            onChange={(e) => setGenre(e.target.value)}
                            placeholder="Select an option"
                            marginBottom="2"
                        >
                            <option value="Food">Food blogs</option>
                            <option value="Travel">Travel blogs</option>
                            <option value="Health">Health and fitness blogs</option>
                            <option value="Lifestyle">Lifestyle blogs</option>
                        </Select>
                        <Input
                            type="text"
                            value={image}
                            onChange={(e) => setImage(e.target.value)}
                            placeholder="Image URL"
                            marginBottom="2"
                        />
                        <Input
                            type="text"
                            value={description}
                            onChange={(e) => setDescription(e.target.value)}
                            placeholder="Description"
                            marginBottom="2"
                        />
                    </ModalBody>
                    <ModalFooter>
                        <Button onClick={handleUpdateDetails} colorScheme="blue">
                            Update Details
                        </Button>
                        <Button onClick={closeModal}>Cancel</Button>
                    </ModalFooter>
                </ModalContent>
            </Modal>
        </>
    );
};

export default DeleteandUpdate;